module.exports = __webpack_public_path__ + "static/media/daily_exprenses_fisdom.a02b7aaa.svg";